import styles from './styles.module.scss';

export const LoadingContent = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.loader}>
                <span className={styles.loaderBlock}></span>
                <span className={styles.loaderBlock}></span>
                <span className={styles.loaderBlock}></span>
                <span className={styles.loaderBlock}></span>
                <span className={styles.loaderBlock}></span>
                <span className={styles.loaderBlock}></span>
                <span className={styles.loaderBlock}></span>
                <span className={styles.loaderBlock}></span>
                <span className={styles.loaderBlock}></span>
            </div>
        </div>
    );
};
